import React from "react";
import { Link } from "gatsby";
import * as styles from "./promo.module.css";

const Promo = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h2>Struggling with Web Development?</h2>
        {/* <h3>STOP WASTING MONEY!</h3> */}
        <h3>Join 3,500+ readers!</h3>
        <p className={styles.subtitle}>
          Learn from my 10+ year experience - in one place.
        </p>
        <ul>
          <li>✅ Anatomy of HTML and CSS</li>
          <li>✅ Get good at ReactJS and Javascript</li>
          <li>✅ Build fast and secure Web applications</li>
          <li>✅ 400+ Pages of content</li>
          <li>✅ 50+ Interesting project ideas</li>
          <li>✅ Homework exercises and Interview prep</li>
          <li>⏰ Limited time offer</li>
        </ul>
        <Link
          to="https://ngninja.gumroad.com/l/html2react/blog"
          target="_blank"
          title="HTML To React"
        >
          <div className={styles.link}>
            <p className="text-black">Claim 70% OFF</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Promo;
